<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll>
          <v-toolbar-title class="font-weight-black primary--text"
            >Parámetros</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="exportarExcel"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> sim_card_download </v-icon>
              </v-btn>
            </template>
            <span>Exportar a Excel</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarCarga"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> file_upload </v-icon>
              </v-btn>
            </template>
            <span>Carga masiva de datos</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="addItem"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> add </v-icon>
              </v-btn>
            </template>
            <span>Ingresar Nuevo Registro</span>
          </v-tooltip>
        </v-app-bar>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Búsqueda General"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchCodigoValue"
                append-icon="search"
                label="Búsqueda por código"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchDescripcionValue"
                append-icon="search"
                label="Búsqueda por descripción"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-sheet class="overflow-y-auto" :max-height="windowHeigth - 100">
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - 250"
            :headers="headers"
            :items="parametros"
            :items-per-page="4"
            :search="search"
            sort-by="codigo"
            class="elevation-1"
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Filas por página',
              'items-per-page-options': [50, 100, 150, -1],
            }"
          >
            <template v-slot:[`item.opciones`]="{ item }">
              <v-btn x-small text dark color="primary" @click="editItem(item)">
                <v-icon x-small>edit</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'A'">
                <v-btn
                  color="success"
                  x-small
                  text
                  dark
                  @click="desactivar(item)"
                >
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn color="error" x-small text dark @click="activar(item)">
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:[`item.es_porcentaje`]="{ item }">
              <div v-if="item.es_porcentaje == true">
                <v-btn
                  color="success"
                  @click="esPorcentaje(item)"
                  x-small
                  text
                  dark
                >
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  color="error"
                  x-small
                  text
                  dark
                  @click="esPorcentaje(item)"
                >
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:[`item.mes`]="{ item }">
              <div>
                {{ item.mes === null ? "" : enteroaMeses(item.mes, true) }}
              </div>
            </template>

            <template v-slot:top>
              <v-dialog v-model="dialog" max-width="500px">
                <v-card ref="form">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            dense
                            ref="codigo"
                            v-model="codigo"
                            :readonly="!editCodigo"
                            :rules="[rules.requerido, rules.min2]"
                            :error-messages="errorMessages"
                            label="Código"
                            placeholder="Código"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            dense
                            ref="descripcion"
                            v-model="descripcion"
                            :rules="[rules.requerido, rules.max50, rules.min2]"
                            :error-messages="errorMessages"
                            label="Descripción"
                            placeholder="Descripción"
                            required
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            outlined
                            dense
                            ref="mes"
                            v-model="mes"
                            :items="meses"
                            :rules="[]"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Mes a Aplicar"
                            required
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            dense
                            reverse
                            ref="monto"
                            v-model="monto"
                            :rules="[
                              rules.requerido,
                              rules.numero,
                              rules.mayorCero,
                            ]"
                            :error-messages="errorMessages"
                            label="Monto"
                            placeholder="Monto"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="close">Cancelar</v-btn>
                    <v-btn color="primary" text @click="guardar">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary" @click="listar">Reset</v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
      <v-dialog v-model="dialogUpload" max-width="50%">
        <v-card>
          <v-card-title>
            <span class="headline">Carga Masiva de Datos</span>
          </v-card-title>
          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="cancel_presentation"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarExcel">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { json2excel, excel2json } from "js2excel";

export default {
  data() {
    return {
      parametros: [],
      windowWidth: window.innerWidth,
      windowHeigth: window.innerHeight,
      nombreExcel:
        "Reporte " +
        new Date().getFullYear() +
        (new Date().getMonth() + 1) +
        new Date().getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds(),
      dialog: false,
      dialogUpload: false,

      page: 1,
      itemsPerPage: 12,
      headers: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Código",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "descripcion",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Es Porcentaje",
          value: "es_porcentaje",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Mes de cálculo",
          value: "mes",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Monto",
          value: "monto",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Activo",
          value: "estado",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        mayorCero: (value) => value > 0.01 || "Ingrese una monto superior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      searchCodigoValue: "",
      searchDescripcionValue: "",
      usuario: this.$store.state.usuario.user,

      meses: [
        { id: 1, descripcion: "ENERO" },
        { id: 2, descripcion: "FEBRERO" },
        { id: 3, descripcion: "MARZO" },
        { id: 4, descripcion: "ABRIL" },
        { id: 5, descripcion: "MAYO" },
        { id: 6, descripcion: "JUNIO" },
        { id: 7, descripcion: "JULIO" },
        { id: 8, descripcion: "AGOSTO" },
        { id: 9, descripcion: "SEPTIEMBRE" },
        { id: 10, descripcion: "OCTUBRE" },
        { id: 11, descripcion: "NOVIEMBRE" },
        { id: 12, descripcion: "DICIEMBRE" },
      ],
      editedIndex: -1,
      editCodigo: false,
      mostrarErrores: false,

      id: "",
      codigo: "",
      descripcion: "",
      monto: "",
      file: null,

      valida: 0,
      mes: "",
      validaMensaje: [],

      adCodigo: "",
      errorMessages: "",
      error: "",
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
        monto: this.monto,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    name() {
      this.errorMessages = "";
    },
  },

  created() {
    this.listar();
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },
    exportarExcel() {
      let me = this;
      try {
        json2excel({
          data: me.parametros,
          name: "Parámetros",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error(e);
      }
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/parametros/cargarExcel", formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    listar() {
      let me = this;
      axios
        .get("api/parametros/listar")
        .then(function (response) {
          me.parametros = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarCarga() {
      this.dialogUpload = true;
    },
    editItem(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.monto = item.monto;
      this.mes = item.mes;
      this.es_porcentaje =
        item.es_porcentaje === null ? false : item.es_porcentaje;
      this.descripcion = item.descripcion;
      this.editedIndex = 1;
      this.editCodigo = false;
      this.dialog = true;
    },
    addItem() {
      this.editCodigo = true;
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    enteroaMeses(numeroMes, mayus) {
      var meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      var mesLetras = "";

      if (!isNaN(numeroMes) && numeroMes >= 1 && numeroMes <= 12) {
        mayus
          ? (mesLetras = meses[numeroMes - 1].toUpperCase())
          : (mesLetras = meses[numeroMes - 1]);
      } else {
        mesLetras = "Todos";
      }
      return mesLetras;
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.validaMensaje = [];
      this.editedIndex = -1;
    },
    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.editedIndex > -1) {
        //codigo para editar
        let me = this;
        axios
          .put("api/parametros/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            monto: me.monto,
            mes: me.mes,
            usuario: me.usuario,
            es_porcentaje: me.es_porcentaje,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/parametros/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/parametros/activar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    esPorcentaje(item) {
      let me = this;
      axios
        .put(
          "api/parametros/esPorcentaje/" +
            item.id +
            "/" +
            item.usuario +
            "/" +
            item.es_porcentaje,
          {}
        )
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Cambio Realizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/parametros/desactivar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    filtroCodigo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCodigoValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCodigoValue.toLowerCase());
    },
    filtroDescripcion(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchDescripcionValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchDescripcionValue.toLowerCase());
    },
  },
};
</script>
